import { useGetProductPriceRangesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { productPriceRangesColumns, type ProductPriceRangeRow } from '../constants/productPriceRangesColumns';

export const ProductPriceRangesList = () => {
    const {
        loading: productPriceRangesLoading,
        data: productPriceRangesData,
        error: productPriceRangesError,
    } = useGetProductPriceRangesQuery({ pollInterval: 5000 });

    if (productPriceRangesLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!productPriceRangesData || productPriceRangesError) {
        throw new Error('Une erreur est survenue lors de la récupération des gammes de prix');
    }

    const { productPriceRanges } = productPriceRangesData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<ProductPriceRangeRow>
                columns={productPriceRangesColumns}
                data={productPriceRanges}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/product-price-range/${row._id}`}
                searchPlaceholder="Nom de la gamme"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
